const defaultTimeOut = 1000;
export class Analytics {
  static sendAnalyticsEvent = (thdAnalyticsEvent, timeOut = () => (defaultTimeOut)) => new Promise((resolve) => {
    if (!window.digitalData.event) {
      window.digitalData.event = [];
    }
    window.digitalData.event.push(thdAnalyticsEvent);
    window.setTimeout(resolve(), timeOut);
  });
}

const exportObj = {
  Analytics,
};

export default exportObj;
